import { Profiles } from 'types/user';

export enum APPS {
  DRILLX_SMART_OPERATIONS = 'DRILLX_SMART_OPERATIONS',
}

export enum APP_MODULES {
  // DRILLX SMART OPS
  HOME = 'HOME',
  GLOBAL_FEEDBACK = 'GLOBAL_FEEDBACK',
  EDDR = 'EDDR',
  LESSONS_LEARNT = 'LESSONS_LEARNT',
  USER_ADMIN = 'USER_ADMIN',
  WELL_GROUPS = 'WELL_GROUPS',
  DRILLX_COCKPIT = 'DRILLX_COCKPIT',
  ADMIN_PO = 'ADMIN_PO',
}

export const allModules = Object.values(APP_MODULES);

export const modulesAllowedForInternal = Object.values(APP_MODULES).filter(
  module => !module.endsWith('_ADMIN') && !module.endsWith('_PO'),
);

export const modulesAllowedForExternal = modulesAllowedForInternal.filter(
  module => module !== APP_MODULES.LESSONS_LEARNT,
);

export const modulesAllowedForDrillx = Object.values(APP_MODULES)
  .filter(module => module.endsWith('_ADMIN'))
  .concat(modulesAllowedForInternal);

export const modulesAllowedForReportingPartner = [APP_MODULES.EDDR, APP_MODULES.HOME];

export const allowedModules = {
  [Profiles.NO_ACCESS]: [] as APP_MODULES[],
  [Profiles.PO]: allModules,
  [Profiles.DRILLX]: modulesAllowedForDrillx,
  [Profiles.INTERNAL]: modulesAllowedForInternal,
  [Profiles.EXTERNAL]: modulesAllowedForExternal,
  [Profiles.REPORTING_PARTNER]: modulesAllowedForReportingPartner,
  [Profiles.REPORTING_PARTNER_WITH_COSTS]: modulesAllowedForReportingPartner,
};
